<template>
  <div id="contact" class="footer-wrapper span-full bgblack" style="background-image:url('/static/images/footer-bg.jpg')" data-type="layout">
    <div class="table-wrap">
      <div class="table-cell">
        <div class="content-750">
          <h3>{{page.title}}</h3>
          <div class="entry-content pt3" v-html="page.content"></div>
          <contact></contact>
        </div>
      </div>
    </div>
    <div class="footer-credits pb2">
      <div class="span-3">
        <div class="item text-left">
          <a target="_blank" href="//www.naturaselection.com/"><img src="/static/images/footer-credits-naturaplastickill-1.png" class="pr1" alt=""></a>
          <a target="_blank" href="//www.plasticpollutioncoalition.org/"><img src="/static/images/footer-credits-naturaplastickill-2.png" alt=""></a>
          <p>Designed by <a href="http://septimo.co/" target="_blank">Séptimo Studio</a></p>
        </div>
        <div class="item">
          <p>Natura — All Rights Reserved {{year}}</p>
          <p><a v-bind:href="'mailto:'+footer.email">{{footer.email}}</a></p>
        </div>
        <div class="item text-right">
          <a v-bind:href="footer.instagram" target="_blank"><icon name="instagram"></icon></a>
          <a v-bind:href="footer.facebook" target="_blank"><icon name="facebook"></icon></a>
          <a v-bind:href="footer.twitter" target="_blank"><icon name="twitter"></icon></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import misc from '../js/scripts.js'
  import Contact from './Contact'
  export default {
    name: 'footer',
    components: {
      Contact
    },
    data(){
      return {
        year: '',
        page: {},
        footer: {},
      }
    },
    watch: {
      '$route': 'getContent'
    },
    methods:{
      getPage(){
        if( localStorage.getItem('language') === 'en' ){
          return this.axios.get(process.env.site.url + '/wp-json/wp/v2/pages?slug=contact')
        } else {
          return this.axios.get(process.env.site.url + '/wp-json/wp/v2/pages?slug=contacto&lang=es')
        }
      },
      getOptions(){
        return this.axios.get(process.env.site.url + '/wp-json/acf/v2/options')
      },
      getContent(){
        this.axios.all([this.getPage(), this.getOptions()]).then(this.axios.spread( (page, options) => {
          this.footer = options.data.acf
          this.page = page.data[0].acf
        }))
      },
      fadeFooterIn(){
        // Display header
        if( misc.get_viewport().height > 748 ){
          var footer_pos_top = document.querySelector('.content-wrapper').getBoundingClientRect().bottom
          var is_visible = (misc.get_viewport().height - footer_pos_top >= 0) ? true : false 
          var part = parseInt(((misc.get_viewport().height - footer_pos_top)*100) / misc.get_viewport().height)
        } else {
          var footer_pos_top = document.querySelector('.footer-wrapper').getBoundingClientRect().top
          var is_visible = footer_pos_top < 400 ? true : false
          var part = parseInt((misc.get_viewport().height - document.querySelector('.footer-wrapper').getBoundingClientRect().top)*100/misc.get_viewport().height)
        }
         if(is_visible && part > 60 && !this.$el.classList.contains('active') ){
          this.$el.classList.add('active')
        }
        if(!is_visible || part < 60 ){
          this.$el.classList.remove('active')
        }
      }
    },
    created(){
      this.getContent()

      var today = new Date();
      this.year = today.getFullYear();
    },
    mounted(){
      this.$nextTick( () => {
        window.addEventListener('scroll', this.fadeFooterIn )
      })
    },
    destroyed(){
      window.removeEventListener('scroll', this.fadeFooterIn )
    }
  }
</script>


// WEBPACK FOOTER //
// Footer.vue?496cff7c